<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">
          21. FIDEICOMISOS
        </h4>
      </b-col>

      <b-list-group sm="12">
        <b-list-group-item
          v-for="(item, index) in fideicomisos.fideicomiso"
          :key="index"
        >
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Fifeicomisos</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label>Tipo Relacion:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.tipoRelacion"
                    :options="tipoRelacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label>Tipo Fideicomiso:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.tipoFideicomiso"
                    :options="tipoFideicomiso"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label>Tipo Participación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.tipoParticipacion"
                    :options="tipoParticipacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.rfcFideicomiso"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <h6 style="text-align: center">Fifeicomitente</h6>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Persona:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.fideicomitente.tipoPersona"
                    :options="tipoPersona"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group>
                  <label>Razon Social:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fideicomitente.nombreRazonSocial"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fideicomitente.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
                <b-col md="12">
                <h6 style="text-align: center">Fiduciario</h6>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>Razon Social:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fiduciario.nombreRazonSocial"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fiduciario.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
                 <b-col md="12">
                <h6 style="text-align: center">Fideicomisario</h6>
              </b-col>
             
              <b-col md="6">
                <b-form-group>
                  <label>Razon Social:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fideicomisario.nombreRazonSocial"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    type="text"
                    v-model="item.fideicomisario.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
               <b-col sm="3">
                <b-form-group>
                  <label>Tipo Persona:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.fideicomisario.tipoPersona"
                    :options="tipoPersona"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group>
                  <label>Sector:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    class="mb-3"
                    v-model="item.sector.clave"
                    :options="sector"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaSectorValor(index)"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Ubicación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosFideicomisos[index].cambios = true"
                    v-model="item.extanjero"
                    :options="extranjero"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <br />
          <!-- FIN formulario -->

          <br />
          <hr />
          <b-col md="12">
            <b-row style="text-align: center">
              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="primary"
                  size="sm"
                  @click="guardarFidecomiso(index)"
                  >Guardar</b-button
                >
                <p v-if="cambiosFideicomisos[index].cambios" class="error-text">
                  <i>No se han guardado los cambios</i>
                </p>
              </b-col>

              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="danger"
                  size="sm"
                  @click="eliminarFideicomiso(index)"
                  >Eliminar fidecomiso</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoFideicomiso()"
          >Agregar Fideicomiso</b-button
        >
      </b-col>
    </b-row>
    <br />

    <!--ACLARACIONES-->
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>Aclaraciones observaciones:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="fideicomisos.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button  variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
       <b-col md="4" style="text-align: center">
      <b-button
        v-if="status !== 'Concluida'"
        variant="primary"
        @click="actualizarObservaciones()"
        :disabled="enviando"
        >Guardar cambios</b-button
      >
      <br />
      <p v-if="cambios" class="error-text">
        <i>No se han guardado los cambios</i>
      </p>
       </b-col>
      <b-col md="2" >
        <b-button

          variant="secondary"
          @click="verSeccion(20)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
     
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: { Loader, Datetime },
  props: ["fideicomisos", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      contador: 0,
      enviando: false,
      cambios: false,
      cambiosFideicomisos: [],

      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      tipoFideicomiso: ["PUBLICO", "PRIVADO", "MIXTO"],
      tipoParticipacion: [
        "FIDEICOMITENTE",
        "FIDUCIARIO",
        "FIDEICOMISARIO",
        "COMITE_TECNICO"
      ],
      tipoRelacion: ["DECLARANTE", "PAREJA", "DEPENDIENTE_ECONOMICO"],
      extranjero: ["MX", "EX"],
      tipoPersona: ["FISICA", "MORAL"],
      sector: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "OTRO" }
      ]
    };
  },
  methods: {
    nuevoFideicomiso() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/fideicomisos/" +
            this.$route.params.id +
            "/fideicomiso",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          
          // this.banderaEditar = true;
          let objeto = { _id: this.contador, cambios: false };
          this.cambiosFideicomisos.push(objeto);
          //VERIFICAR
          this.fideicomisos.fideicomiso.push(res.data.fideicomiso);
          this.contador++;
          this.enviando = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },

    guardarFidecomiso(index) {
      this.enviando = true;

      axios
        .put(
          //declaraciones/V2/fideicomisos/:idDeclaracion/beneficio/:idFideicomiso
          this.httpURL +
            "/declaraciones/V2/fideicomisos/" +
            this.$route.params.id +
            "/fideicomiso/" +
            this.fideicomisos.fideicomiso[index]._id,
          {
            tipoOperacion: this.fideicomisos.fideicomiso[index].tipoOperacion,
            tipoRelacion: this.fideicomisos.fideicomiso[index].tipoRelacion,
            tipoFideicomiso: this.fideicomisos.fideicomiso[index]
              .tipoFideicomiso,
            tipoParticipacion: this.fideicomisos.fideicomiso[index]
              .tipoParticipacion,
            rfcFideicomiso: this.fideicomisos.fideicomiso[index].rfcFideicomiso,
            fideicomitenteTipoPersona: this.fideicomisos.fideicomiso[index]
              .fideicomitente.tipoPersona,

            fideicomitenteNombreRazonSocial: this.fideicomisos.fideicomiso[
              index
            ].fideicomitente.nombreRazonSocial,
            fideicomitenteRFC: this.fideicomisos.fideicomiso[index]
              .fideicomitente.rfc,
            fiduciarioNombreRazonSocial: this.fideicomisos.fideicomiso[index]
              .fiduciario.nombreRazonSocial,

            fiduciarioRFC: this.fideicomisos.fideicomiso[index].fiduciario.rfc,
            fiduciarioNombreRazonSocial: this.fideicomisos.fideicomiso[index]
              .fiduciario.nombreRazonSocial,

            fideicomisarioTipoPersona: this.fideicomisos.fideicomiso[index]
              .fideicomisario.tipoPersona,
            fideicomisarioNombreRazonSocial: this.fideicomisos.fideicomiso[
              index
            ].fideicomisario.nombreRazonSocial,
            fideicomisarioRFC: this.fideicomisos.fideicomiso[index]
              .fideicomisario.rfc,

            sectorClave: this.fideicomisos.fideicomiso[index].sector.clave,
            sectorValor: this.fideicomisos.fideicomiso[index].sector.valor,
            extanjero: this.fideicomisos.fideicomiso[index].extanjero
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.cambiosFideicomisos[index].cambios = false;
          }

          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },

    seleccionaSectorValor(index) {
      let indice = this.sector.findIndex(
        x => x.clave == this.fideicomisos.fidecomiso[index].sector.clave
      );
      this.fideicomisos.fidecomiso[index].sector.valor = this.sector[
        indice
      ].valor;
    },
    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/fideicomisos/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",

          {
            ninguno: this.fideicomisos.ninguno,
            aclaracionesObservaciones: this.fideicomisos
              .aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
         
         
        });
    },
    eliminarFideicomiso(index) {
      swal({
        text: "¿Está seguro en eliminar el fideicomiso?",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/fideicomisos/" +
                this.$route.params.id +
                "/fideicomiso/" +
                this.fideicomisos.fideicomiso[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
         
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.fideicomisos.fideicomiso.splice(index, 1);
                this.cambiosFideicomisos.splice(index, 1);
                this.contador--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
             
            });
        }
      });
    },
    agregarTitular(index) {
      let indice = this.titular.findIndex(x => x.valor == this.tmpTitular);
      let nuevoTitular = {
        clave: this.titular[indice].clave,
        valor: this.tmpTitular
      };
      this.mueblesFinal[index].titular.push(nuevoTitular);
      

      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/bienesMuebles/" +
            this.$route.params.id +
            "/bienMueble/" +
            this.mueblesFinal[index]._id +
            "/titular",

          {
            titularClave: this.titular[indice].clave,
            titularValor: this.tmpTitular
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
  
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    agregarTercero(index) {
      let nuevoTercero = {
        _id: this.contadorTercero,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
      };
      this.mueblesFinal[index].tercero.push(nuevoTercero);
      this.contadorTercero++;
    },
    agregarTransmisor(index) {
      let nuevoTransmisor = {
        _id: this.contadorTransmisor,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null,
        relacion: { descripcion: null, clave: null, valor: null }
      };
      this.mueblesFinal[index].transmisor.push(nuevoTransmisor);
      this.contadorTransmisor++;
    },

    guardarTercero(id, index, i) {
      
      var x = id.length;
  
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/bienesMuebles/" +
              this.$route.params.id +
              "/bienMueble/" +
              this.mueblesFinal[index]._id +
              "/tercero",

            {
              tipoPersona: this.mueblesFinal[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.mueblesFinal[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.mueblesFinal[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            
            this.banderaEditar = true;
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.mueblesFinal[index].tercero[i]._id = res.data.tercero._id;
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
      
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/bienesMuebles/" +
              this.$route.params.id +
              "/bienMueble/" +
              this.mueblesFinal[index]._id +
              "/tercero/" +
              id,
            {
              tipoPersona: this.mueblesFinal[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.mueblesFinal[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.mueblesFinal[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.enviando = false;
            }
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      }
    },
    guardarTransmisor(id, index, i) {
      if (id > 100) {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/bienesMuebles/" +
              this.$route.params.id +
              "/bienMueble/" +
              this.mueblesFinal[index]._id +
              "/transmisor/" +
              id,

            {
              relacionClave: this.mueblesFinal[index].transmisor[i].relacion
                .clave,
              relacionValor: this.mueblesFinal[index].transmisor[i].relacion
                .valor,
              tipoPersona: this.mueblesFinal[index].transmisor[i].tipoPersona,
              nombreRazonSocial: this.mueblesFinal[index].transmisor[i]
                .nombreRazonSocial,
              rfc: this.mueblesFinal[index].transmisor[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
            this.enviando = false;
            this.cambios = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      } else {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/bienesMuebles/" +
              this.$route.params.id +
              "/bienMueble/" +
              this.mueblesFinal[index]._id +
              "/transmisor",
            {
              relacionClave: this.mueblesFinal[index].transmisor[i].relacion
                .clave,
              relacionValor: this.mueblesFinal[index].transmisor[i].relacion
                .valor,
              tipoPersona: this.mueblesFinal[index].transmisor[i].tipoPersona,
              nombreRazonSocial: this.mueblesFinal[index].transmisor[i]
                .nombreRazonSocial,
              rfc: this.mueblesFinal[index].transmisor[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.mueblesFinal[index].transmisor[i]._id =
                res.data.transmisor._id;
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo tercero."
            });
            this.enviando = false;
          });
      }

      ///////////////////
    },
    eliminarTitular(index, i) {
     
      swal({
        text: "¿Está seguro en eliminar el titular?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesmuebles/" +
                this.$route.params.id +
                "/bienMueble/" +
                this.mueblesFinal[index]._id +
                "/titular/" +
                this.mueblesFinal[index].titular[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
          
              this.mueblesFinal[index].titular.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
              
            });
        }
      });
    },
    eliminarTercero(index, i) {
      swal({
        text: "¿Está seguro en eliminar tercero?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesMuebles/" +
                this.$route.params.id +
                "/bienMueble/" +
                this.mueblesFinal[index]._id +
                "/tercero/" +
                this.mueblesFinal[index].tercero[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
          
              this.mueblesFinal[index].tercero.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
            
            });
        }
      });
    },
    eliminarTransmisor(index, i) {
      swal({
        text: "¿Está seguro en eliminar transmisor?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/bienesMuebles/" +
                this.$route.params.id +
                "/bienMueble/" +
                this.mueblesFinal[index]._id +
                "/transmisor/" +
                this.mueblesFinal[index].transmisor[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
              
              this.mueblesFinal[index].transmisor.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    }
  },

  created() {
   
    this.fideicomisos.fideicomiso.forEach(Element => {
      let objeto = { _id: Element._id, cambios: false };
      this.cambiosFideicomisos.push(objeto);
      if (Element.tipoOperacion === "AGREGAR") {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
